import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPowerAutomateLogo = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 26,
	height: 26,
	viewBox: "0 0 26 26",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M2.52367 3.75977H2.5215C1.75233 3.75977 1.34121 4.66706 1.84929 5.24556L8.66508 13.0001L16.7191 3.87785C16.5886 3.82314 16.4477 3.79118 16.3031 3.79064L2.52367 3.75977Z",
			fill: "url(#paint0_linear_6676_74115)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.6157 8.12278L17.1166 4.1567C17.0072 4.03266 16.8717 3.93949 16.7228 3.8772L8.66875 12.9999L1.87462 20.6997C1.3595 21.2837 1.77062 22.1996 2.54629 22.2067L8.38817 22.2029L20.6157 8.12278Z",
			fill: "url(#paint1_linear_6676_74115)"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M23.9537 11.9071L20.6165 8.12354L8.38889 22.2085L16.4034 22.2031C16.6775 22.1782 16.9342 22.0552 17.1178 21.8467L23.9537 14.0965C24.5056 13.4714 24.5056 12.5327 23.9537 11.9071Z",
			fill: "url(#paint2_linear_6676_74115)"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .05,
			d: "M8.67217 13.0001L16.7262 3.87791C16.5957 3.8232 16.4548 3.79124 16.3102 3.7907L16.0811 3.79016L8.3125 12.5912L8.67217 13.0001Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsx("path", {
			opacity: .07,
			d: "M8.48611 12.7963L8.66541 13L16.7194 3.8778C16.6257 3.83826 16.5255 3.81605 16.4237 3.80359L8.48611 12.7963Z",
			fill: "black"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint0_linear_6676_74115",
				x1: 5.56729,
				y1: .716141,
				x2: 13.4003,
				y2: 9.20622,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#196DE5" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#1351C8"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint1_linear_6676_74115",
				x1: 9.31008,
				y1: 12.6576,
				x2: 15.0279,
				y2: 19.6153,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#4D9FFF" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#1667EB"
				})]
			}),
			/* @__PURE__ */ _jsxs("linearGradient", {
				id: "paint2_linear_6676_74115",
				x1: 14.8033,
				y1: 14.7384,
				x2: 18.1145,
				y2: 20.2845,
				gradientUnits: "userSpaceOnUse",
				children: [/* @__PURE__ */ _jsx("stop", { stopColor: "#70BCFD" }), /* @__PURE__ */ _jsx("stop", {
					offset: 1,
					stopColor: "#4A9FF9"
				})]
			})
		] })
	]
});
export default SvgPowerAutomateLogo;
